export function EmailIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <title>E m a i l</title>
      <path
        d="M22.512 3C22.928 3 23.28 3.144 23.568 3.432C23.856 3.72 24 4.072 24 4.488V19.488C24 19.904 23.856 20.256 23.568 20.544C23.28 20.848 22.928 21 22.512 21H1.512C1.096 21 0.736 20.848 0.432 20.544C0.144 20.256 0 19.904 0 19.488V4.488C0 4.072 0.144 3.72 0.432 3.432C0.736 3.144 1.096 3 1.512 3H22.512ZM22.512 19.488V8.04L12 13.08L1.512 8.04V19.488H22.512ZM22.512 6.36V4.488H1.512V6.36L12 11.4L22.512 6.36Z"
        fill="currentColor"
      />
    </svg>
  );
}
